import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { EditDocxTermsDialogComponent } from './edit-docx-terms-dialog.component'

@NgModule({
    declarations: [EditDocxTermsDialogComponent],
    exports: [EditDocxTermsDialogComponent],
    imports: [CommonModule],
})
export class EditDocxTermsDialogModule {}
